import React, { useEffect, useState } from "react";
import useFetchData from "../Hooks/useFetchData";
import { Link } from "react-router-dom";
import Api from "../Hooks/Api";
import { LineChart, ColumnChart, PieChart } from "react-chartkick";
import { Bar, Lone, Pie } from "react-chartjs-2";
const Dashboard = (props) => {
  const Staff = useFetchData("api/DashBoard/1/1/staff");
  const Students = useFetchData("api/DashBoard/1/Students");
  const Institutions = useFetchData("api/DashBoard/ApprovedInstitutions");
  const UsersLoggedinandActive = useFetchData(
    "api/DashBoard/1/all/Users/activenow/systemusers"
  ); 
  const [notification, setnotification] = useState({});
  
  const AllUsersLoggedinand = useFetchData(
    "api/DashBoard/1/all/Users/AllLogins/systemusers"
  );
  const Courses = useFetchData("api/Courses");
  const StudentsPerCounty = useFetchData("api/Students/1/1");
  const StudentsPerCountyOptions = [];
  if (StudentsPerCounty.response) {
    StudentsPerCounty.response.map((k, i) => {
      let col = [k.countyName, k.count];
      StudentsPerCountyOptions.push(col);
    });
  }
  let studebtspergenderdata = [];
  let totalStudents = 0;
  let totalfemale = 0;
  let totalmale = 0;
  if (Array.isArray(Students.response)) {
    let male = Students.response.filter((option) => option.gender.toLowerCase().trim() === "male");
    let female = Students.response.filter((option) => option.gender.toLowerCase().trim() === "female");

    if (male.length > 0) {
      studebtspergenderdata.push(["Male", male[0].id]);
      totalmale = male[0].id;
    }
    if (female.length > 0) {
      studebtspergenderdata.push(["Female", female[0].id]);
      totalfemale = female[0].id;
    }

    totalStudents = totalmale + totalfemale;
  } else {
    // console.log("Empty",Students.response)
  }


  const fetchSummaries = async () => {
    try {
        Api.get("api/dashboard/getTotals")
        .then(function (response) { 
          if (response.status=== 200) {
            const data =response.data;
            setnotification(data);
          }
        })
        .catch(function (error) {
        })
        .then(function () {
          // always executed
        })           

        
    } catch (error) {
        console.error("Error fetching incidentTypes:", error);
    }
};
useEffect(() => { 
  fetchSummaries();  
}, []); 

  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item"></li>
        <li class="breadcrumb-item active">DashBoard</li>
      </ol>
      <h1 class="page-header mb-3">DashBoard</h1>
      <hr />
      {/* <h4>Approval/Action (s) Pending</h4> */}
      <div>
        {/* <div class="row">
          <div class="col-xl-4 col-md-6">
            <div class="widget widget-stats bg-info">
              <div class="stats-icon">
                <i class="fa fa-link"></i>
              </div>
              <div class="stats-info">
                <h4>MOU ({notification.mou
                  ? notification.mou
                  : 0})</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="widget widget-stats bg-info">
              <div class="stats-icon">
                <i class="fa fa-link"></i>
              </div>
              <div class="stats-info">
                <h4>Users ({notification.response
                  ? notification.response.users
                  : 0})</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="widget widget-stats bg-info">
              <div class="stats-icon">
                <i class="fa fa-desktop"></i>
              </div>
              <div class="stats-info">
                <h4>PRODUCTS ({notification.products
                  ? notification.products
                  : 0})</h4>
              </div>
            </div>
          </div>    
        </div> */}
        {/* <hr /> */}
        {/* <h4>Summary</h4> */}
        <div class="row">
          <div class="col-xl-3 col-md-6">
            <div class="widget widget-stats bg-info">
              <div class="stats-icon">
                <i class="fa fa-bullhorn"></i>
              </div>
              <div class="stats-info">
                <h4>MARKETING CAMPAIGNS</h4>
                <p>
                {notification.marketingCampaign
                  ? notification.marketingCampaign
                  : 0}
                </p>
              </div>
              <div class="stats-link">
                <Link to="/Marketing">
                  View Detail <i class="fa fa-arrow-alt-circle-right"></i>
                </Link>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="widget widget-stats bg-blue">
              <div class="stats-icon">
                <i class="fa fa-book"></i>
              </div>
              <div class="stats-info">
                <h4>TOTAL MOUs</h4>
                <p>{notification.mou
                  ? notification.mou
                  : 0}</p>
              </div>
              <div class="stats-link">
                <Link to="/AddMous">
                  View Detail <i class="fa fa-arrow-alt-circle-right"></i>
                </Link>
              </div>
            </div>
          </div>

          <div class="col-xl-3 col-md-6">
            <div class="widget widget-stats bg-orange">
              <div class="stats-icon">
                <i class="fa fa-binoculars"></i>
              </div>
              <div class="stats-info">
                <h4>PRODUCTS</h4>
                <p>{notification.products
                  ? notification.products
                  : 0}</p>
              </div>
              <div class="stats-link">
                <Link to="/AddProducts">
                  View Detail <i class="fa fa-arrow-alt-circle-right"></i>
                </Link>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="widget widget-stats bg-red">
              <div class="stats-icon">
                <i class="fa fa-ambulance"></i>
              </div>
              <div class="stats-info">
                <h4>TOTAL INCIDENTS</h4>
                <p>{notification.incidents
                  ? notification.incidents
                  : 0}</p>
              </div>
              <div class="stats-link">
                <Link to="/SecurityIncident">
                  View Detail <i class="fa fa-arrow-alt-circle-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-8">
            <div
              class="panel-heading ui-sortable-handle"
              style={{ background: "black", height: "33px", color: "white" }}
            >
              <h4
                className="panel-title text-center"
                style={{ padding: "5px" }}
              >
                Incidents PER COUNTY
              </h4>
            </div>
            <div style={{ background: "white", marginTop: "4px" }}>
              <ColumnChart data={StudentsPerCountyOptions} />
            </div>
          </div>
          <div class="col-xl-4">
            <div
              class="panel-heading ui-sortable-handle"
              style={{ background: "black", height: "33px", color: "white" }}
            >
              <h4
                className="panel-title text-center"
                style={{ padding: "5px" }}
              >
                 DESTINATIONS PER COUNTY
              </h4>
            </div>
            <div style={{ background: "white" }}>
              <PieChart data={studebtspergenderdata} />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6">
            <div
              class="panel-heading ui-sortable-handle"
              style={{ background: "black", height: "33px", color: "white" }}
            >
              <h4 className="panel-title" style={{ padding: "5px" }}>
                Active Users
              </h4>
            </div>
            <div style={{ background: "white", marginTop: "4px" }}>
              {UsersLoggedinandActive.response
                ? UsersLoggedinandActive.response.map((k, i) => {
                  return (
                    <div className="col-sm">
                      <b>
                        {k.name}:{k.id}
                      </b>
                    </div>
                  );
                })
                : null}
            </div>
          </div>
          <div class="col-xl-6">
            <div
              class="panel-heading ui-sortable-handle"
              style={{ background: "black", height: "33px", color: "white" }}
            >
              <h4 className="panel-title" style={{ padding: "5px" }}>
                All logins
              </h4>
            </div>
            <div style={{ background: "white", marginTop: "4px" }}>
              {AllUsersLoggedinand.response
                ? AllUsersLoggedinand.response.map((k, i) => {
                  return (
                    <div className="col-sm">
                      <b>
                        {k.name}:{k.totalLogins}
                      </b>
                    </div>
                  );
                })
                : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
